import React from 'react'

const LockOpenIcon = () => {
	return (
		<svg width={31} height={27} viewBox='0 0 31 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M28.9 10.934H12.727c-1.16 0-2.1.955-2.1 2.134v11.798c0 1.18.94 2.135 2.1 2.135H28.9c1.16 0 2.1-.956 2.1-2.135V13.068c0-1.179-.94-2.134-2.1-2.134z'
				fill='currentColor'
			/>
			<path
				d='M16.802 11.251V8.107a8.16 8.16 0 00-2.331-5.721A7.893 7.893 0 008.843.016c-2.11 0-4.135.852-5.627 2.37A8.16 8.16 0 00.885 8.107v3.113h3.49V8.107c0-1.209.472-2.368 1.313-3.223a4.446 4.446 0 013.17-1.335c1.188 0 2.329.48 3.17 1.335a4.596 4.596 0 011.312 3.223v3.144h3.462z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default LockOpenIcon
